import { useMemo } from 'react';

import { ArticleCommentSkeleton } from '@web/newsfeed/Article/ArticleComments/ArticleCommentsSkeleton/ArticleCommentSkeleton';

type Props = {
  placeholdersCount: number;
};

export const ArticleCommentsSkeleton = ({ placeholdersCount }: Props) => {
  const placeholders = useMemo(() => {
    const elements = [];
    for (let i = 0; i < placeholdersCount; i++) {
      elements.push(<ArticleCommentSkeleton key={i} />);
    }
    return elements;
  }, [placeholdersCount]);

  return <div data-testid="article-comments-skeleton">{placeholders}</div>;
};
